export default __webpack_public_path__ + "static/media/SearchIcon.62b8bd37.svg";